/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import { toMessages } from 'config/messages';

export default toMessages('FormV2', {
  NotSetDefaultError: 'Please enter a value.'
});